module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATVJREFUWEftlrFKxEAQhmfmDXyN3WzS5AXS+xYWViIe2ghioY2lqOU1djYWgoWFoI29IQFBOLCVYCEWUbMZWSFwiGSLu0yanXLZ3fn2Z+afRRg5cOT8EACCAkGBpSqQ5/kKEb11rY2I11rr1b5W9wIURTGp6/okTdNvn2cMBcAA8IyI21rrqz6IIQG6vLfMPDHG5P+BSAAAIlpmnlpr95IkeZ0HEQGYS/jOzIdEdKy1/nLr0gAdy4yZd4wxl2MB/IIg4r21dp+I7pbdhq4LvOFqAwBOmXlzDIDHtm3XAGA2hBH1KfDJzAdVVR1lWdZI18CDe3Ucx0+d5FIAH4i4q5Q6Q8RW2gduiGhdKfUi7YRuwm1FUXQuPgvKsrxommbjr+2KKeA1gAU3eP8DC97vPR4AggJBgR+KN8ghengxQAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/next3.png
// module id = e+ic
// module chunks = 1